import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {PAYMENT_FLOWS_QUERY_KEY} from "../queryKeys";
import {PaymentFlow, PaymentFlowCreatePayload} from "./types";

const createPaymentFlow = async (payload: PaymentFlowCreatePayload): Promise<PaymentFlow> => {
  const response = await axiosReachInstance.post<PaymentFlow, AxiosResponse<PaymentFlow>, PaymentFlowCreatePayload>(
    "/payment_flows",
    payload
  );
  return response.data;
};

export const useCreatePaymentFlow = (
  options?: BaseMutationOptions<PaymentFlow, PaymentFlowCreatePayload>
): BaseUseMutationResult<PaymentFlow, PaymentFlowCreatePayload> => {
  return useBaseMutation<PaymentFlow, PaymentFlowCreatePayload>(createPaymentFlow, {
    ...options,
    prefixKeysToReset: () => [[PAYMENT_FLOWS_QUERY_KEY]],
  });
};
